import { render, staticRenderFns } from "./fab-icon-examples.vue?vue&type=template&id=6a1d9271&"
import script from "./fab-icon-examples.vue?vue&type=script&lang=js&"
export * from "./fab-icon-examples.vue?vue&type=script&lang=js&"
import style0 from "./fab-icon-examples.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports